// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */
export const SEARCH_PERSONALIZATION_BY_SITE_USER_CACHE_KEY = 'search-personalization-site-user';
export const SEVEN_DAY_MS_TTL = 1000 * 7 * 24 * 60 * 60; // 7 days
export const ONE_DAY_MS_TTL = 1000 * 24 * 60 * 60; // 1 day
export const ONE_HOUR_MS_TTL = 1000 * 60 * 60; // 1 hour
export const RIGHT_PANEL_TRAIT = 'search_user_3p_recommendations_right_panel_v1';
